import React from "react";
import { Alert, Row, Col, Form, Button } from "reactstrap";

// hooks
import { useRedux } from "../../hooks/index";

// router
import { Link, Navigate } from "react-router-dom";

// validations
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";

// hooks
import { useProfile } from "../../hooks";

//actions
import { userForgetPassword } from "../../redux/actions";

// components
import NonAuthLayoutWrapper from "../../components/NonAutnLayoutWrapper";
import AuthHeader from "../../components/AuthHeader";
import FormInput from "../../components/FormInput";
import Loader from "../../components/Loader";
import { createSelector } from "reselect";

import i18next from "../../i18n"
import { strUcFirst } from "../../utils/index";

interface RecoverPasswordProps {}
const RecoverPassword = (props: RecoverPasswordProps) => {
  // global store
  const { dispatch, useAppSelector } = useRedux();

  // const { forgetError, forgetSuccessMsg, forgetPassLoading } = useAppSelector(
  //   state => ({
  //     forgetError: state.ForgetPassword.forgetError,
  //     forgetSuccessMsg: state.ForgetPassword.forgetSuccessMsg,
  //     forgetPassLoading: state.ForgetPassword.loading,
  //   })
  // );


  const errorData = createSelector(
    (state : any) => state.ForgetPassword,
    (state) => ({
      forgetError: state.forgetError,
      forgetSuccessMsg: state.forgetSuccessMsg,
      forgetPassLoading: state.loading,

    })
  );
  // Inside your component
  const { forgetError,forgetSuccessMsg ,forgetPassLoading} = useAppSelector(errorData);

  const resolver = yupResolver(
    yup.object().shape({
      email: yup
        .string()
        .email("This value should be a valid email.")
        .required("Please Enter E-mail."),
    })
  );

  const defaultValues: any = {};

  const methods = useForm({ defaultValues, resolver });
  const {
    handleSubmit,
    register,
    control,
    formState: { errors },
  } = methods;

  const onSubmitForm = (values: object) => {
    dispatch(userForgetPassword(values));
  };

  const { userProfile, loading } = useProfile();
  if (userProfile && !loading) {
    return <Navigate to={{ pathname: "/dashboard" }} />;
  }

  return (
    <NonAuthLayoutWrapper>
      <Row className=" justify-content-center my-auto">
        <Col sm={8} lg={6} xl={5} className="col-xxl-4">
          <div className="py-md-5 py-4">
            <AuthHeader
              title={strUcFirst(i18next.t('auth.forgot_pwd'))}
              subtitle={strUcFirst(i18next.t('auth.reset_pwd'))}
            />

            {forgetError && forgetError ? (
              <Alert color="danger">{forgetError}</Alert>
            ) : null}
            {forgetSuccessMsg ? (
              <Alert color="success">{forgetSuccessMsg}</Alert>
            ) : null}
            {!forgetError && !forgetSuccessMsg && (
              <Alert color="info" className="text-center my-4">
                {strUcFirst(i18next.t('auth.reset_pwd_msg'))}
              </Alert>
            )}

            <Form
              onSubmit={handleSubmit(onSubmitForm)}
              className="position-relative"
            >
              {forgetPassLoading && <Loader />}
              <div className="mb-3">
                <FormInput
                  label={strUcFirst(i18next.t('form.email_lg'))}
                  type="text"
                  name="email"
                  register={register}
                  errors={errors}
                  control={control}
                  labelClassName="form-label"
                  placeholder={strUcFirst(i18next.t('form.email_input'))}
                  className="form-control"
                />
              </div>
              <div className="text-center mt-4">
                <Button color="primary" className="w-100" type="submit">
                {strUcFirst(i18next.t('auth.reset'))}
                </Button>
              </div>
            </Form>
            <div className="mt-5 text-center text-muted">
              <p>
              {strUcFirst(i18next.t('auth.remember_it'))} {" "}
                <Link
                  to="/auth-login"
                  className="fw-medium text-decoration-underline"
                >
                  {" "}
                  {strUcFirst(i18next.t('auth.signin'))}
                </Link>
              </p>
            </div>
          </div>
        </Col>
      </Row>
    </NonAuthLayoutWrapper>
  );
};

export default RecoverPassword;
